<template>
  	<PinBatchList />
</template>

<script>

// @ is an alias to /src
import PinBatchList from "@/components/Client/PinBatch/PinBatchList.vue";

export default {
  name: "PinBatchLists",
  components: {
    PinBatchList,
  },
};
</script>
